export default {
  // 页面标题
  title: 'Aha',
  newCampaign: 'New Campaign',

  // AI代理
  aiAgent: {
    placeholder: 'Interrupt me anytime with any question',
  },

  // 模态框标题
  modalTitles: {
    paymentDetails: 'Payment details',
  },

  // 按钮文本
  buttons: {
    saveDraft: 'Save draft',
    next: 'Next',
    update: 'Update',
    release: 'Release',
    signUpForMore: 'Sign up free for more',
    saveAndExit: 'Save & Exit',
  },

  // 帮助提示
  help: {
    whatHappensAfterPublish: 'What happens after you publish？',
    skipStepTooltip: 'Confident with your campaign information settings? You can skip this step and go straight to "Budget and results"',
  },

  // 关闭确认模态框
  closeModal: {
    title: 'Unsaved changes',
    description: 'You have unsaved changes, are you sure you want to exit?',
    notSaved: 'NOT SAVED',
  },

  // 消息提示
  messages: {
    rechargeFailed: 'Recharge failed',
    rechargeSuccessful: 'Recharge Successful! Your balance has been updated.',
  },

  // 错误消息
  errors: {
    getCampaignDetailFailed: 'Failed to get campaign details',
    bindOrgFailed: 'Failed to bind organization',
    networkError: 'Network error. Please refresh your page and try again.',
  },

  // 产品类型
  productType: {
    webApp: 'web app',
    mobileApp: 'mobile app',
    desktopApp: 'desktop app',
    browserExtension: 'browser extension',
    physicalProduct: 'physical product',
  },

  // 业务模式
  businessModel: {
    toBusiness: 'to business',
    toCustomer: 'to customer',
    b2b: 'B2B',
    b2c: 'B2C',
  },

  // 活动目标
  campaignObjective: {
    awareness: 'Awareness',
    websiteTraffic: 'Website Traffic',
    installs: 'Installs',
    leads: 'Leads',
    signUps: 'Sign-ups',
    sales: 'Sales',
  },

  // 活动目标子类型
  campaignObjectiveSubType: {
    subscription: 'Subscription',
    payAsYouGo: 'Pay-as-You-Go',
    oneTimePayment: 'One-time payment',
  },

  // 目标表单标签
  targetForm: {
    installs: {
      title: 'Your click-to-install conversion rate',
      desc: 'You can enter either your current conversion rate or your target conversion rate here to estimate your campaign\'s result.',
      tips: 'Industry benchmark: 60%-80%.',
      message: 'please enter click-to-install conversion rate',
    },
    signUps: {
      title: 'Your click-to-sign-up conversion rate',
      desc: 'You can enter either your current conversion rate or your target conversion rate here to estimate your campaign\'s result.',
      tips: 'Industry benchmark: 20%-50%.',
      message: 'please enter click-to-sign-up conversion rate',
    },
    leads: {
      title: 'Your click-to-lead conversion rate',
      desc: 'You can enter either your current conversion rate or your target conversion rate here to estimate your campaign\'s result.',
      tips: 'Industry benchmark: 1%-5%.',
      message: 'please enter click-to-lead conversion rate',
    },
  },

  // 目标选项
  targetOptions: {
    traffic: {
      title: 'Traffic',
      desc: 'Direct the right audience to your destinations, such as your website, app, social media pages, and more. Link clicks (PV) will be tracked.',
    },
    leads: {
      title: 'Leads',
      desc: 'Collect leads for your business or brand. Encourage customers to take action.',
    },
  },

  // 成功模态框
  successModal: {
    congratulations: 'Congratulations! Your campaign is created and will receive influencer applications within 24–48 hours after review.',
    congratulationsColdEmail: 'Congratulations! Your campaign is created.',
    descriptionGuide: 'In the meantime, get an overview of essentials of Aha to help you maximize your success',
    descriptionColdEmail: 'We\'re now setting up your email domain and accounts. The email warmup process typically takes at least 7 days, after which we will start sending out invites.',
    descriptionNormal: 'In the meantime, check campaign details or get an overview of essentials of Aha to help you maximize your success',
    viewCampaign: 'View campaign',
    importantSeeNext: 'Important: see what happens next',
    checkHeadInstructions: 'Check Aha Instructions',
  },

  // 高级设置
  advancedSetting: {
    title: 'Advanced settings',
  },

  // 设置页面
  settings: {
    title: 'Settings',
    save: 'Save',
    cancel: 'Cancel',
    saveSuccess: 'Save success!',
    placements: 'Placements',
    languages: 'Languages',
    locations: 'Locations',
    influencerMarketingPostDate: 'Influencer marketing post date',
    affiliateMarketingContentPostDate: 'Affiliate marketing content post date',
    landingPageLink: 'Provide the link where the audience will be taken when they click',
    selectAll: 'Select All',
    pleaseSelectAtLeastOnePlatform: 'Please select at least one platform content type',
    pleaseSelectAtLeastOneRegion: 'Please select at least one region',
    pleaseSelectPostDate: 'Please select post date',
    flexiblePostTime: 'Flexible post time: Creators can publish their content as soon as it\'s approved.',
    fixedPostTime: 'Fixed post time: Creators are required to post within a designated time window.',
    selectCampaignStartDates: 'Select campaign start dates at least one month in advance to ensure influencers have ample time to produce content.',
    influencersRequiredToPost: 'Influencers are required to post content within 7 days after their applications are approved',
    currentSelectionMayLimit: 'Your current selection may limit influencer matches. To improve results, try selecting more platforms, languages, or locations to broaden your reach.',
    selectedPlatformsMayLimit: 'Selected platforms may limit your campaign\'s reach. To maximize performance, please consider including more platforms.',
    chooseSocialPlatforms: 'Choose the social platforms and content types you would like the influencers to engage with.',
    enterLanguageToShowAds: 'Enter a language to show your ads to people who use the language.',
    chooseBroadAreaToShowAds: 'Choose a broad area to show your ads within can improve results.',
    specifyParticularDateWindow: 'Specify if you have a particular date window in mind for when you would like the influencers to post their content.',
    trackingLinkDescription: 'Aha will generate a unique tracking link for each influencer from this link to help you track performance (e.g., views, clicks, CPM, and CPC).',
    coldEmailSettings: 'Cold email',
    emailSenderName: 'Email sender name',
    letAIAgentSetCPM: 'Let AI agent set the CPM',
    letAIAgentSetCPMDesc: 'Let AI agent set the CPM for you. Good for brands that have no CPM limit',
    smartMode: 'Smart mode',
    setMaximumCPMManually: 'Set maximum CPM manually',
    setMaximumCPMManuallyDesc: 'Set maximum CPM cap manually. Good for brands that have strict CPM limit',
    manualMode: 'Manual mode',
    letAIAgentNegotiatePrice: 'Let AI agent negotiate the price',
    letAIAgentNegotiatePriceDesc: 'Let AI agent negotiate the best price for you. Good for brands that have no budget limit for each influencer',
    setPriceLimitsManually: 'Set price limits manually',
    setPriceLimitsManuallyDesc: 'Set the influencer budget manually. Good for brands that have strict budget limit',
    highestBudgetPerInfluencer: 'Highest budget per influencer',
    lowestBudgetPerInfluencer: 'Lowest budget per influencer',
    emailSenderTitle: 'Email sender title',
    emailToForwardConvertedLeads: 'Email to forward converted leads',
    pleaseEnterEmailSenderName: 'Please enter email sender name',
    pleaseEnterEmailSenderTitle: 'Please enter email sender title',
    pleaseEnterEmailSenderForwardEmail: 'Please enter email sender forward email',
    pleaseEnterValidName: 'Please enter a valid name',
    pleaseEnterValidEmailAddress: 'Please enter a valid email address',
    advancedInfluencerSettings: 'Advanced influencer settings',
    influencerFilterWarning: 'Please note that applying influencer filter logic will limit your influencer supply. Please set with caution.',
    influencerSettings: {
      performanceActivity: 'Performance & activity',
      minimumPredictedViews: 'Minimum predicted views',
      minimumPredictedViewsTooltip: 'Aha uses historic data to predicted views for influencers. If you don\'t set, the default predicted view threshold is YouTube: 400, TikTok: 1500, Twitter: 700, LinkedIn: 500, Instagram: 1500',
      minimumFollowers: 'Minimum followers',
      postingFrequency: 'Posting frequency',
      postingFrequencyRequired: 'Please input the posting frequency',
      postsPerMonth: 'posts per month',
      lastPostTime: 'Last post time',
      lastPostTimeRequired: 'Please input the last post time',
      lastPostTimePlaceholder: 'Last post within xx days',
      price: 'Price',
      maximumCpm: 'Maximum CPM',
      maximumPricePerInfluencer: 'Maximum price per influencer',
      minimumPricePerInfluencer: 'Minimum price per influencer',
      audience: 'Audience',
      audienceGender: 'Audience gender',
      genderRequired: 'Please select the gender',
      female: 'Female',
      male: 'Male',
      percentRequired: 'Please input the percent',
      audienceGenderDesc: 'Select the primary gender in the influencer\'s audience and the minimum percentage required.',
      audienceAge: 'Audience age',
      ageRangeRequired: 'Please select the age range',
      audienceAgeDesc: 'Select one or more age ranges and the minimum audience percentage required.',
    },
    emailSenderNamePlaceholder: 'This will serve as sender name for your cold emails',
    emailSenderTitlePlaceholder: 'This will serve as sender\'s title for your cold emails',
    emailForwardPlaceholder: 'We will forward hot quality leads to this email',
    developedEnglishSpeakingMarkets: 'Developed English-speaking markets',
    developedMarkets: 'Developed markets',
    developedAndEmergingMarkets: 'Developed and emerging markets',
    locationBagsDescription: 'Click a location group above to quickly add predefined countries/regions.',
    productExplainerVideo: 'Product explainer video',
    productExplainerVideoDesc: 'Upload a YouTube video explaining your products or service to help creators better understand your campaign requirements.',
    customBrandGuidelines: 'Custom brand guidelines',
    customBrandGuidelinesDesc: 'Requirements that you\'d like the creators to follow in addition to',
    platformRequirements: 'Platform requirements.',
    customBrandGuidelinesDescEnd: 'If you already have a campaign brief prepared, you’re welcome to include it here.',
    referenceInfluencers: 'Reference influencers',
    referenceInfluencersDesc: 'Upload a list of influencers you like, and Aha will find similar ones for your campaign.',
    downloadTemplate: 'Download template',
    blocklist: 'Blocklist',
    blocklistDesc: 'Upload a list of influencers you do not wish to work with.',
    brandAssets: 'Brand assets',
    brandAssetsDesc: 'Upload the brand assets you wish to share with creators via Google Drive or other links. Please adhere to the',
    brandAssetsUploadRequirements: 'Brand assets upload requirements',
    brandAssetsDescEnd: 'so that creator content can achieve optimal results.',
    add: 'Add',
    upload: 'Upload',
    pleaseInputValidYoutubeLink: 'Please input Valid Youtube Link!',
    pleaseInputValidLink: 'Please input Valid Link!',
    pleaseEnterBrandAssetsLink: 'Please enter the Brand assets link...',
    mustUsePlaceholder: 'e.g. Must use xxx features.',
    theFileDoesNotContain: 'the file does not contain any influencer profile',
    notice: 'NOTICE',
    confirmToAdd: 'Confirm to add',
    notNow: 'Not now',
    kindReminder: 'Kind reminder',
    youHaveSelectedCountriesOrLanguages: 'You have selected the following countries or langauges:',
    doYouWantToAddRecommended: 'Do you want to add the following recommended languages or countries?',
    pricingPlan: 'Pricing plan',
    freelancingModel: 'Freelancing model',
    payAsYouGo: 'Pay as you go',
    commissionDescription: 'Our commission is 10% for each influencer collaboration.',
    employmentModel: 'Employment model',
    yearly: 'Yearly',
    twoMonthsFree: '2 months free / year',
    noCommissionsDescription: 'No commissions, 7.9% of your influencer marketing budget / mo. Save',
    vsPayAsYouGo: 'vs pay-as-you-go.',
    affiliateMarketing: 'Affiliate marketing',
    affiliateRecruitmentBudget: 'Affiliate recruitment budget',
    affiliateRecruitmentBudgetDesc: 'Total budget to recruit affiliates through Aha. You\'ll only be charged when you confirm influencers to join, and commissions are paid separately after they generate sales. Affiliate costs usually range from a few dollars up to $100.',
    pleaseSelectBudgetForAffiliate: 'Please select budget',
    affiliateCommissionRate: 'Affiliate commission rate',
    pleaseEnterAffiliateCommissionRate: 'please enter affiliate commission rate',
    industryBenchmarkCommission: 'Industry benchmark: 10%- 80%',
    averageOrderValue: 'Average order value',
    pleaseEnterAverageOrderValue: 'Please enter average order value',
    industryBenchmarkOrder: 'Industry benchmark: 50-500 USD(B2B), 10-100 USD(B2C)',
    coldEmail: 'Cold email',
    coldEmailDescription: 'You\'ll be prompted to make a payment of 30 USD to cover basic costs including domain set up fee, emails warmup fee, email outreach fee, etc. when you launch your campaign.',
    budgetToAcquireConvertedLeads: 'Budget to acquire converted leads',
    pleaseSelectBudgetForLeads: 'Please select budget',
    positiveResponseRateOutOfSentEmails: 'Positive response rate out of sent emails',
    pleaseEnterPositiveReplyRate: 'please enter positive reply rate',
    industryBenchmarkResponseRate: 'Industry benchmark: 3% – 10% (B2B), 1% – 5% (B2C)',
    positiveResponseToPurchaseRate: 'Positive response to purchase rate',
    pleaseEnterConversionRate: 'please enter converison rate',
    industryBenchmarkConversionRate: 'Industry benchmark: 8% – 25% (B2B), 3% – 15% (B2C)',
    averageCustomerLifetimeValue: 'Average customer lifetime value',
    pleaseEnterAverageCustomerLifetimeValue: 'Please enter average customer lifetime value',
    // 其他设置相关文本
    placementsInfoModal: {
      title: 'Platform Content Formats & Use Cases',
      platform: 'Platform',
      contentFormat: 'Content Format',
      keyFeatures: 'Use Cases',
      youtubeDedicated: 'Dedicated videos',
      youtubeIntegrated: 'Integrated videos',
      instagramReel: 'Reels',
      instagramCarouselPost: 'Carousel posts',
      tiktokVideo: 'Videos',
      Posts: 'Posts',
      youtubeDedicatedDesc: 'Full video entirely focused on the brand — best for new product launches, in-depth reviews, or brand storytelling.',
      youtubeIntegratedDesc: "Branded segment within an influencer’s video, making up at least 30% of total content — a cost-efficient option for natural but substantial exposure.",
      instagramReelDesc: 'Short videos, strong algorithm reach — great for product launches, viral trends, and quick brand exposure.',
      instagramCarouselPostDesc: 'Up to 10 slides, mix of images and videos. Ideal for storytelling, product demos, comparisons, and tutorials.',
      tiktokVideoDesc: 'Vertical short videos mixed into user feed — powerful for mass reach, creative storytelling, and young audiences.',
      twitterPostDesc: 'Flexible posts with text, images, or videos — suited for topical engagement, brand voice, and viral reach.',
      linkedinImagePostDesc: 'Branded visuals or carousel posts showing product value, insights, or collaborations — ideal for professional storytelling and credibility building.',
      linkedinVideoPostDesc: 'Influencer-led videos sharing use cases, expert opinions, or testimonials — strong for trust-building and engagement among decision-makers.',
      linkedinImagePost: 'LinkedIn image posts',
      linkedinVideoPost: 'LinkedIn video posts',
    },
    twitterPostTooltip: "From our experience with past campaigns, we've observed lower performance on Twitter. While we don't typically recommend it, please feel free to reach out if you'd like to discuss using it for your campaign.",
    languageMissPanel: {
      title: 'Considering your target regions, you might want to add these languages:',
      addAll: 'Add All',
    },
    onlyCsvFiles: 'Only .csv files',
    desiredInfluencerProfiles: 'Desired influencer profiles',
    desiredInfluencerProfilesDesc: 'This profile tells us what kind of influencers you’re looking for, so Aha can automatically match the best-fit influencers for your campaign. Example: AI Tools Daily — influencers who review and explain new AI tools with clear, practical examples.',
    pleaseInputMustDo: 'Please input must do',
    matchingAccuracy: {
      title: 'Matching accuracy',
      focusMode: {
        label: 'Focus mode',
        desc: 'Focuses on highly aligned influencers for better match accuracy. Expect higher costs and a longer campaign cycle.',
      },
      scaleMode: {
        label: 'Scale mode',
        desc: 'Expands the influencer pool while keeping solid relevance, improving efficiency, lowering costs, and shortening the campaign cycle.',
      },
      maxScaleMode: {
        label: 'Max scale mode',
        desc: 'Maximizes reach by widening relevance boundaries, greatly lowering costs and accelerating the campaign cycle.',
      },
    },
  },

  // 业务信息
  businessInformation: {
    title: 'Business Information',
    companyName: 'Company Name',
    website: 'Website',
    industry: 'Industry',
    coreSellingPoints: 'Core selling points',
    coreAudiences: 'Core product audiences',
    advancedSettings: 'Advanced Settings',
    gender: 'Gender',
    age: 'Age',
    interest: 'Interest',
    aiGeneratedDescription: 'These details are generated by Aha based on an analysis of your brand. Please review and customize them as necessary.',
    basicInformation: 'Basic information',
    businessLogo: 'Business Logo',
    logoFormatNote: 'Only support uploading logos in SVG format.',
    upload: 'Upload',
    businessName: 'Business name',
    productServiceType: 'Product / Service type',
    benchmarkBrands: 'Benchmark brands',
    importantMatters: 'Important Matters',
    importantMattersDescription: 'Please fill in any information that needs special attention from the creator below, such as: product usage prohibitions, essential points to mention, accounts to @tag, etc.',
    importantMattersPlaceholder: 'Important Matters...',
    businessIntroduction: 'Business introduction',
    pleaseEnterBusinessName: 'Please enter business name',
    pleaseEnterBenchmarkBrands: 'Please enter benchmark brands',
    benchmarkBrandsDescription: 'We’ll use your benchmark brands to match both influencers who are a great fit to promote them and those who’ve partnered with these brands before. Put the brands most similar to yours at the top to improve matching accuracy.',
    pleaseEnterCampaignName: 'Please enter campaign name',
    pleaseSelectGender: 'Please select gender',
    pleaseSelectAge: 'Please select age',
    pleaseEnterInterests: 'Please enter the interests of the audience, separated by ","',
    pleaseFillInInfluencerAccessCredits: 'Please fill in the influencer access & credits information',
    endorsementPlaceholder: 'e.g., funding, major partners, traction, revenue...',
    endorsementPlaceholderDesc: 'Add highlights that boost influencer trust and increase collaboration rates.',
    brandHighlightsEndorsements: 'Brand highlights & endorsements',
    pleaseEnterBusinessIntroduction: 'Please enter business introduction',
    forInfluencerMatching: {
      label: 'For influencer matching',
      tooltip: 'This information helps Aha find influencers whose audience and content best match your campaign.',
    },
  },

  // 选择目标
  selectObjective: {
    title: 'Select Campaign Objective',
    awareness: 'Awareness',
    traffic: 'Traffic',
    leads: 'Leads',
    installs: 'Installs',
    signUps: 'Sign-ups',
    sales: 'Sales',
    // 其他目标相关文本
  },

  // 平台内容标签
  platformContentLabel: {
    youtubeDedicated: 'YouTube dedicated videos',
    youtubeIntegrated: 'YouTube integrated videos',
    tiktokVideo: 'TikTok videos',
    instagramReel: 'Instagram Reels',
    instagramCarouselPost: 'Instagram carousel posts',
    twitterPost: 'Twitter / X posts',
    linkedinPost: 'LinkedIn posts',
    linkedinImagePost: 'LinkedIn image posts',
    linkedinVideoPost: 'LinkedIn video posts',
  },

  // 预算出价
  budgetBidding: {
    title: 'Budget & Bidding',
    dailyBudget: 'Daily Budget',
    totalBudget: 'Total Budget',
    budgetPerInfluencer: 'Budget per Influencer',
    budgetLimitWarning: 'Please set a reasonable budget limit for each influencer. An unreasonable budget limit may result in insufficient creator supply for your campaign. If you\'re unsure how to set a budget limit, recommend selecting Smart Mode.',
    chooseBudgetLimit: 'Choose your budget limit',
    maximumCpm: 'Maximum CPM',
    influencerMarketing: 'Influencer marketing',
    totalInfluencerPayment: 'Total influencer payment',
    totalBudgetDescription: 'Set your total campaign budget — you can adjust it anytime after launch. Payments are only processed after content delivery, and your budget determines how many influencers can be invited to your campaign.',
    pleaseSelectBudgetForInfluencer: 'Please select budget',
    name: 'Name',
    followers: 'Followers',
    estViewsPerPost: 'Est. views/post',
    matchReason: 'Match reason',
    profile: 'Profile',
    view: 'View',
    sampleInfluencersTitle: 'Sample influencers you may collaborate with',
    sampleInfluencersDesc: 'Based on the campaign information you provided, we\'ve pre-matched these sample influencers to help you assess audience fit. If they\'re not ideal, feel free to adjust your campaign inputs.',
    notSeeingIdealMatches: 'Not seeing ideal matches?',
    adjustYourInputs: 'Adjust your inputs',
    currentPlan: 'Current plan',
    perMonth: '/ mo',
    influencerFee: 'Influencer fee',
    verifyYourAuthorization: 'Verify your authorization',
    authorizationDescription: 'To ensure the legal validity of your signed authorization document with Aha, please provide your full legal name for official verification. Campaign cannot be released without successful authorization.',
    fullLegalName: 'Full legal name',
    fullLegalNamePlaceholder: 'eg: John Doe',
    // Influencer application preview related
    influencerApplicationPreview: 'Influencer application preview',
    actualValuesMayFluctuate: 'Actual values may fluctuate due to factors such as market dynamics, influencer supply, and related conditions. The influencers displayed above are for preview and reference only; the final matching will occur once the campaign is released.',
    // Subscription related
    monthlySubscriptionCancellationRate: 'Monthly subscription cancellation rate',
    pleaseEnterMonthlySubscriptionCancellationRate: 'Please enter monthly subscription cancellation rate',
    industryBenchmarkSubscription: 'Industry benchmark: 1%-3% (B2B), 5%-10% (B2C)',
    clickToPurchaseRate: 'Click-to-purchase rate',
    pleaseEnterClickToPurchaseRate: 'Please enter click-to-purchase rate',
    industryBenchmarkClickToPurchase: 'Industry benchmark: 1% - 5%.',
    // Pay-as-you-go related
    clickToPayConversionRate: 'Click-to-pay conversion rate',
    pleaseEnterClickToPayConversionRate: 'Please enter click-to-pay conversion rate',
    payingUserARPU: 'Paying User ARPU',
    pleaseEnterPayingUserARPU: 'Please enter paying user ARPU',
    payingUserARPUDescription: 'The average revenue generated per paying user.',
    // Table column titles
    estimatedPrice: 'Estimated price',
    predictedCPM: 'Predicted CPM',
    predictedViews: 'Predicted views',
    predictedCPC: 'Predicted CPC',
    predictedClicks: 'Predicted clicks',
    // Landing page URL related
    conversionTrackingAlert: 'Make sure the page you\'re directing traffic to is set up correctly to measure conversions. Conversion tracking helps you understand how effectively your ad clicks lead to valuable customer activity and optimize your ads for those actions. Learn more:',
    viewHeadDevelopmentDoc: 'View Aha Development Doc',
    pleaseEnterValidLink: 'Please enter a valid link',
    landingPagePlaceholder: 'The audience will visit this link after watching the influencer\'s content',
    back: 'Back',
    continue: 'Continue',
    partnershipAuthorization: 'Partnership Authorization',
    authorizationText1: 'By confirming this, you\'re officially authorizing Aha',
    authorizationText2: '(operated by Ahalab.ai Inc.) to manage this campaign on your behalf.',
    authorizationDescription1: 'This authorization document will be visible to influencers when they receive tasks, giving them confidence that the partnership is legitimate. This streamlines the process and reduces unnecessary back-and-forth.',
    authorizationDescription2: 'While most influencers won\'t need further confirmation,',
    authorizationDescription2Highlight: 'some may still reach out to verify directly with you and your team.',
    authorizationDescription2End: 'You can choose to respond or ignore these messages - our support team handles all follow-ups to keep things running smoothly.',
    reminder: 'Reminder',
    iConfirmAuthorization: 'I Confirm Authorization',
    verifyYourBusiness: 'Verify your business',
    sensitiveIndustryNotice: 'We noticed this campaign relates to a sensitive industry. To help us verify the legitimacy of the brand, please upload supporting documents — such as business license, or any other supporting documentations.',
    emailMismatchNotice: 'We noticed that your work email doesn\'t match the campaign website\'s domain. To ensure',
    formalConsentFromBrand: 'formal consent from the brand',
    emailMismatchNoticeEnd: 'has been obtained, please upload any relevant documents, such as a business certificate, agency agreement, or any other supporting materials.',
    upload: 'Upload',
    modalBack: 'Back',
    modalContinue: 'Continue',
    ifYouNeedAssistance: 'If you need any assistance, don\'t hesitate to',
    contactUs: 'contact us.',
    fileSizeExceedError: 'The file size cannot exceed 10MB!',
    failedToUploadLogo: 'Failed to upload logo',
    setCpmCap: 'Set your CPM cap',
  },

  // 预览匹配
  previewSampleMatches: {
    title: 'Preview Sample Matches',
    saveSuccess: 'Save success!',
    feedbackTitle: 'Preview sample matches to align expectations',
    feedbackDescriptionLoading: 'You can adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine the samples.',
    feedbackDescriptionFocusMode: 'Here are samples generated in Focus mode. Not meeting expectations? Adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine results.',
    feedbackDescriptionScaleMode: 'Here are samples from Scale mode (includes Focus). Not meeting expectations? Adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine results.',
    feedbackDescriptionMaxScaleMode: 'Here are samples from Max mode (includes Focus and Scale). Not meeting expectations? Adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine results.',
    notGettingRightMatches: 'Not getting the right matches?',
    highNotMatchRateMessage: 'Over 40% of influencers were marked “Not a match.” This suggests some parts of your campaign info, such as <b>match accuracy, business introduction, selling points, core audience, or desired influencer profiles</b>, may need refinement.\nWould you like Aha to auto-optimize these sections? Your manual edits will remain unchanged.',
    moreThan40Percent: 'More than 40% of the creators you reviewed were marked as',
    notAMatchPeriod: 'Not a match .',
    thisUsuallyMeansInfo: 'This usually means your campaign information',
    likeAudienceCore: '(like audience, core selling points, etc. )',
    mayNeedFineTuned: 'may need to be fine-tuned to improve accuracy. Would you like to review and refine your setup now?',
    continueAnyway: 'Continue anyway',
    editCampaignInfoManually: 'Edit campaign info manually',
    optimizeWithAI: 'Optimize with AI',
    matchReason: 'Match reason',
    match: 'Match',
    emptyMessage: 'We’re preparing sample matches to fine-tune your results. This process takes about 2 minutes.',
    emptyMessage2: 'Initial test matches help validate the direction before running the full influencer matching.',
    emptyMessageTips: 'This is a test match, not the final matching result.',
    endCard: {
      description: "Your initial match looks great! Based on your feedback, we’ll move forward to the official matching stage to connect you with the most relevant influencers once your campaign goes live.",
      return: 'Update your feedback',
      notMatchDesc: 'To improve the quality and relevance of your influencer matches, we recommend adjusting your campaign information. You can let our AI assistant instantly optimize your campaign or ',
      notMatchDescLink: 'contact us for help.',
      next: 'Next',
      expandWithAISuggestions: 'Optimize campaign info with AI',
      adjustMatchingAccuracyMode: 'Adjust matching accuracy mode'
    },
    notAMatch: 'Not a match',
    emptyMessageTime: '2min',
    timeSecond: 's',
    timeMinute: 'min',
    timeMinutes: 'mins',
  },

  // 创建估算面板
  createEstimatePanel: {
    estimatedCampaignResults: 'Estimated campaign results',
    affiliateMarketingResultsEstimation: 'Affiliate marketing results estimation',
    coldEmailResultsEstimation: 'Cold email results estimation',
    views: 'Views',
    cpm: 'CPM',
    clicks: 'Clicks',
    cpc: 'CPC',
    costPerInstallRange: 'Cost per install range',
    installRange: 'Install range',
    costPerLeadRange: 'Cost per lead range',
    leadRange: 'Lead range',
    costPerSignUpRange: 'Cost per sign-up range',
    signUpRange: 'Sign-up range',
    roiRange: 'ROI range',
    salesRange: 'Sales range',
    arpuCacRange: 'ARPU/CAC range',
    aovCacRange: 'AOV/CAC range',
    cpmAcrossDifferentPlatforms: 'CPM across different platforms',
    numberOfAffiliates: 'Number of affiliates',
    noteSalesEstimates: 'Note: Sales estimates are calculated using industry click-to-purchase conversion benchmarks ranging from 1.5% to 4.5%.',
    potentialConvertedLeads: 'Potential converted leads',
    potentialCustomers: 'Potential customers',
    potentialLifetimeRevenue: 'Potential lifetime revenue',
    roi: 'ROI',
  },

  // 受众
  audiences: {
    title: 'Audiences',
    // 其他受众相关文本
  },

  // 创意
  creatives: {
    title: 'Creatives',
    // 其他创意相关文本
  },

  // 开发策略
  developStrategy: {
    title: 'Develop Strategy',
    // 其他策略相关文本
  },

  // 增长策略
  growthStrategy: {
    title: 'Growth Strategy',
    // 其他增长相关文本
  },

  // 活动创意
  campaignIdeas: {
    title: 'Campaign Ideas',
    // 其他创意相关文本
  },

  // 活动步骤
  campaignSteps: {
    setupCampaign: 'Set up campaign',
    basicInformation: 'Basic information',
    settings: 'Settings',
    previewSampleMatches: 'Preview sample matches',
    budgetAndResults: 'Budget and results',
    enterOtherInformation: 'Enter other information',
    reviewSummary: 'Review summary',
    collapse: 'Collapse',
  },

  // 选择交付模式
  selectDeliveryMode: {
    title: 'Select Delivery Mode',
    serviceModel: 'Service Model',
    contactUsMessage: 'Please contact us to get a free crash course on creator marketing before you release the campaign.',
    serviceModelComparison: 'Service Model Comparison',
    // 其他交付模式相关文本
  },

  // 产品分析
  productAnalysis: {
    title: 'Product Analysis',
    // 其他产品分析相关文本
  },

  // 审核摘要
  reviewSummary: {
    title: 'Review Summary',
    // 其他审核相关文本
  },

  // 添加Stripe
  addStripe: {
    title: 'Add Stripe',
    // 其他Stripe相关文本
  },

  // 落地页URL
  landingPageUrl: {
    title: 'Landing Page URL',
    // 其他落地页相关文本
  },

  // 其他信息
  otherInformation: {
    title: 'Other Information',
    // 其他信息相关文本
  },

  // 进度时间线
  progressTimeline: {
    title: 'Progress Timeline',
    editCampaign: 'Edit Campaign',
    headThinking: 'Aha is thinking...',
    headFinished: 'Aha finished thinking.',
    noMoreInfluencers: 'There are currently no more suitable influencers that match your campaign. If you\'d like to find additional influencers, please consider editing your campaign details. I will then identify and reach out to more influencers based on your updated campaign information.',
    // 其他进度相关文本
  },

  // 网站表单
  websiteForm: {
    title: 'Website Form',
    welcomeMessage: 'Hi {firstName}! Happy to partner with you to build real marketing strategies and run an expert-level campaign. Drop your website URL and I’ll review it, offering a brand overview we can refine together. It also helps me identify the best-fit influencers for your brand.',
    welcomeMessageNoName: 'Hi! Happy to partner with you to build real marketing strategies and run an expert-level campaign. Drop your website URL and I’ll review it, offering a brand overview we can refine together. It also helps me identify the best-fit influencers for your brand.',
    pleaseEnterWebsite: 'Please enter a website',
    pleaseEnterValidWebsite: 'Please enter a valid website',
    websitePlaceholder: 'Enter your product or app website, Amazon link, Shopify link, etc.',
    generate: 'Generate',
    errorOccurred: 'An error occurred. Please try again.',
    // 其他网站表单相关文本
  },
  websiteLoading: {
    settingUpCampaign: 'Setting up campaign',
    readStory: 'Read story',
  },

  // 达人不足引导
  resultGuidance: {
    analyze: 'Analyze whether the available influencers are sufficient...',
    notEmptyTip: 'Please ensure that the platform, language and locations options are not empty, so that we can speculate for you whether the matching talent is enough.',
    insufficientTitle: 'Insufficient',
    insufficientContent: 'Your current settings provide too few influencers, which may limit your campaign’s results. Try expanding placements, languages, or locations to improve results.',
    fairlyBroadTitle: 'Fairly sufficient',
    fairlyBroadContent: 'Your current settings provide a decent pool of influencers. To reach a wider audience, try expanding your placements, languages, or locations.',
    broadTitle: 'Sufficient',
    broadContent: "Available influencer pool based on your settings are sufficient You're on the right track.",
    expandWithAISuggestions: 'Expand with AI suggestions',
    b2bPlatformLimit: 'Your selected platforms may limit campaign reach. Even for B2B, consider adding short, easy-to-watch videos (product demos, pain point jokes, workflow tips) on IG Reels or TikTok.',
  },
  // AI推荐
  aiRecommendation: {
    title: 'AI recommendation',
    description: 'Consider add the following platforms, countries, and languages to scale your results.',
    placements: 'Placements',
    placementsTooltip: 'Choose the social platforms and content types you would like the influencers to engage with.',
    pleaseSelectAtLeastOnePlatform: 'Please select at least one platform content type',
    selectAll: 'Select All',
    languages: 'Languages',
    languagesTooltip: 'Enter a language to show your ads to people who use the language.',
    locations: 'Locations',
    locationsTooltip: 'Choose a broad area to show your ads within can improve results.',
    cancel: 'Cancel',
    add: 'Add',
  }
};
